import { getType, getActionCreator } from 'shared/lib';
const prefix = '@@app/dashboardIndicators';

export const WAIBI_ACCESS_REQUEST = getType(prefix, 'WAIBI_ACCESS_REQUEST');
export const waibiAccessRequest = getActionCreator(WAIBI_ACCESS_REQUEST);
export const WAIBI_ACCESS_SUCCESS = getType(prefix, 'WAIBI_ACCESS_SUCCESS');
export const waibiAccessSuccess = getActionCreator(WAIBI_ACCESS_SUCCESS);
export const WAIBI_ACCESS_ERROR = getType(prefix, 'WAIBI_ACCESS_ERROR');
export const waibiAccessError = getActionCreator(WAIBI_ACCESS_ERROR);
